<template>
  <div id="geomagneticMain">
    <el-row>
      <el-col :span="24"
              class="titleLine">
        <el-breadcrumb separator-class="el-icon-arrow-right"
                       class="titleLine1">
          <el-breadcrumb-item>停车场</el-breadcrumb-item>
          <el-breadcrumb-item>场库设置</el-breadcrumb-item>
          <el-breadcrumb-item>地磁管理</el-breadcrumb-item>
        </el-breadcrumb>
      </el-col>
    </el-row>
    <el-form :inline="true"
             class="pageSearch">
      <el-row>
        <el-col :span="22">
          <el-form-item label="客户::">
            <el-select v-model="pageSearch.fCustID"
                       filterable
                       :clearable="true"
                       placeholder="请选择客户"
                       @change="loadPark"
                       style="width:200px;">
              <el-option v-for="item in cust_list"
                         :key="item.fCustID"
                         :label="item.unionName"
                         :value="item.fCustID">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="场库::">
            <el-select v-model="pageSearch.fParkID"
                       filterable
                       placeholder="请选择场库"
                       style="width:200px;"
                       clearable>
              <el-option v-for="item in park_list"
                         :key="item.fParkID"
                         :label="item.fParkName"
                         :value="item.fParkID">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="地磁通道号::"
                        label-width="100px">
            <el-input placeholder="请输入两位的通道号"
                      v-model="pageSearch.fMagChnlNo"
                      style="width:200px;">
            </el-input>
          </el-form-item>
          <el-form-item label="地磁关键信息::"
                        label-width="100px">
            <el-input placeholder="请输入通道名/IP/SN"
                      v-model="pageSearch.fSearchkeyword"
                      style="width:200px;">
            </el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary"
                       size="small"
                       icon="el-icon-search"
                       @click="init">查询</el-button>
          </el-form-item>
        </el-col>
        <el-col :span="2"
                class="add">
          <el-button type="primary"
                     v-if="is_edit"
                     size="small"
                     @click="add">新增地磁</el-button>
        </el-col>
      </el-row>
    </el-form>
    <el-row>
      <el-col :span="24">
        <el-table :data="pageData"
                  :height="tableHeight"
                  highlight-current-row
                  v-loading="loading"
                  border
                  stripe
                  style="width: 100%">
          <el-table-column width="50"
                           type="index"
                           :index="indexMethod"
                           align="right"
                           label="序号">
          </el-table-column>
          <el-table-column prop="fCustNo"
                           label="客户编号"
                           width="80">
          </el-table-column>
          <el-table-column prop="fParkNo"
                           label="场库编号">
          </el-table-column>
          <el-table-column prop="fParkName"
                           label="场库名称">
          </el-table-column>
          <el-table-column prop="fMagIPAddr"
                           label="地磁网关IP">
          </el-table-column>
          <el-table-column prop="fMagChnlNo"
                           label="地磁通道号">
          </el-table-column>
          <el-table-column prop="fMagSN"
                           label="地磁设备SN">
          </el-table-column>
          <el-table-column prop="fRoadName"
                           label="地磁道路">
          </el-table-column>
          <el-table-column prop="fMagRssi"
                           label="设备信号">
          </el-table-column>
          <el-table-column prop="fMagBat"
                           label="设备电量">
          </el-table-column>
          <el-table-column prop="fMatVer"
                           label="程序版本">
          </el-table-column>
          <el-table-column prop="fLastTime"
                           width="150"
                           label="最后传输时间">
          </el-table-column>
          <el-table-column label="操作"
                           fixed="right"
                           align="center"
                           width="300">
            <template slot-scope="scope">
              <el-button size="mini"
                         type="success"
                         @click="handleInfo(scope.$index, scope.row,true)">查看</el-button>
              <el-button size="mini"
                         type="warning"
                         @click="handleInfo(scope.$index, scope.row,false)">编辑</el-button>
              <el-button size="mini"
                         type="danger"
                         @click="handleDel(scope.$index, scope.row)">删除</el-button>
              <el-button size="mini"
                         type="primary"
                         @click="handleDetail(scope.$index, scope.row)">详情</el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-col>
    </el-row>
    <el-row class="pagination">
      <el-col :span="24">
        <div class="block">
          <span class="demonstration"></span>
          <el-pagination @current-change="handleCurrentChange"
                         @size-change="handleSizeChange"
                         :current-page="pageSearch.pageIndex"
                         :page-size="pageSearch.pageSize"
                         :page-sizes="[10,20,100, 500, 1000]"
                         background
                         layout="total,sizes, prev, pager, next, jumper"
                         :total="pageCount"
                         v-if="pageCount>0">
          </el-pagination>
        </div>
      </el-col>
    </el-row>
    <el-dialog :title="dialogTitle"
               top="7vh"
               width="50%"
               :visible.sync="dialogVisible"
               v-dialogDrag>
      <el-form :model="parkMagdev"
               :rules="rules"
               ref="ruleForm"
               label-width="100px">
        <el-row>
          <el-col :span="12">
            <el-form-item label="客户名称::"
                          prop="fCustID">
              <el-select v-model="parkMagdev.fCustID"
                         filterable
                         clearable
                         placeholder="请选择客户"
                         @change="changePark($event,true)"
                         :disabled="isRead">
                <el-option v-for="item in cust_list"
                           :key="item.fCustID"
                           :label="item.unionName"
                           :value="item.fCustID">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="场库::"
                          prop="fParkID">
              <el-select v-model="parkMagdev.fParkID"
                         filterable
                         clearable
                         placeholder="请选择场库"
                         :disabled="isRead">
                <el-option v-for="item in parkList"
                           :key="item.fParkID"
                           :label="item.fParkName"
                           :value="item.fParkID">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="地磁网关IP::"
                          prop="fMagIPAddr">
              <el-input v-model="parkMagdev.fMagIPAddr"
                        :disabled="isRead"
                        placeholder="例如:192.168.0.1:9000"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="地磁通道号::"
                          prop="fMagChnlNo">
              <el-input v-model="parkMagdev.fMagChnlNo"
                        :disabled="isRead"
                        placeholder="请填写地磁通道号"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="地磁设备SN">
              <el-input v-model="parkMagdev.fMagSN"
                        placeholder="请填写地磁设备SN"
                        :disabled="isRead"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="道路名称::"
                          prop="parkMagdev"
                          class="road_item">
              <el-input v-model="parkMagdev.fRoadName"
                        :disabled="isRead"
                        @keyup.native="address_keyup"
                        placeholder="请填写道路名称"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label=" "
                          style="height:300px;">
              <div class="search_list"
                   v-if="map_search_list.length > 0">
                <el-row :key="index"
                        v-for="(item, index) in map_search_list"
                        @click.native="map_search_change(item, index)">
                  <el-col class="t"
                          :span="24"
                          v-html="item.title"></el-col>
                  <el-col class="a"
                          :span="24"
                          v-html="item.address"></el-col>
                </el-row>
              </div>
              <div id="parkBaiduMap"
                   :style="{ width: (map_search_list.length > 0 ?'70%':'100%'), height:'300px' }"></div>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="经度::"
                          prop="parkMagdev">
              <el-input v-model="parkMagdev.fLongitude"
                        :disabled="isRead"
                        @keyup.native="setAddress"
                        placeholder="经度"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="经度::"
                          prop="parkMagdev">
              <el-input v-model="parkMagdev.fLatitude"
                        :disabled="isRead"
                        @keyup.native="setAddress"
                        placeholder="维度"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row class="fRemark_row">
          <el-col :span="24">
            <el-form-item label="备注::"
                          prop="fRemark">
              <el-input type="textarea"
                        v-model="parkMagdev.fRemark"
                        :disabled="isRead"
                        id="fRemark"
                        placeholder="请填写备注"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer"
           class="dialog-footer">
        <el-button type="primary"
                   @click="submitForm('ruleForm')"
                   v-if="!isRead">保存</el-button>
        <el-button @click="dialogVisible = false">取 消</el-button>
      </div>
    </el-dialog>
    <el-dialog :title="dialogDetailTitle"
               top="7vh"
               width="70%"
               :visible.sync="dialogDetailVisible"
               v-dialogDrag>
      <!-- <el-row class="log_search">
        <el-col :span="24">
          <el-select v-model="deviceLogParam.fIsExp"
                     placeholder="请选择日志类型"
                     clearable>
            <el-option v-for="item in logTypeArray"
                       :key="item.value"
                       :label="item.label"
                       :value="item.value">
            </el-option>
          </el-select>
          <el-input placeholder="请输入监控项目"
                    v-model="deviceLogParam.searchKeyWord"
                    class="search">
          </el-input>
          <el-button type="primary"
                     size="small"
                     icon="el-icon-search"
                     @click="init_log">查询</el-button>
        </el-col>
      </el-row> -->
      <el-row>
        <el-col :span="24">
          <el-table :data="pageDetailData"
                    v-loading="logLoading"
                    height="500"
                    border
                    stripe
                    style="width: 100%">
            <el-table-column width="50"
                             type="index"
                             :index="DetailIndexMethod"
                             align="right"
                             label="序号">
            </el-table-column>
            <el-table-column prop="fCustNo"
                             label="客户编号"
                             width="80">
            </el-table-column>
            <el-table-column prop="fOpLastTime"
                             label="最后操作时间"
                             width="170">
            </el-table-column>
            <el-table-column prop="fParkNo"
                             label="场库编号">
            </el-table-column>
            <el-table-column prop="fParkName"
                             label="场库名称">
            </el-table-column>
            <el-table-column prop="fMagIPAddr"
                             label="地磁网关IP">
            </el-table-column>
            <el-table-column prop="fMagChnlNo"
                             label="地磁通道号">
            </el-table-column>
            <el-table-column prop="fMagSN"
                             label="地磁设备SN">
            </el-table-column>
            <el-table-column prop="fRoadName"
                             label="地磁道路">
            </el-table-column>
            <!-- <el-table-column prop="fMagRssi"
                             label="设备信号">
            </el-table-column>
            <el-table-column prop="fMagBat"
                             label="设备电量">
            </el-table-column> -->
            <el-table-column prop="fMatVer"
                             label="程序版本">
            </el-table-column>
            <el-table-column prop="fCarStatusName"
                             width="80px"
                             label="车况状态">
            </el-table-column>
            <el-table-column prop="fExpStatusName"
                             width="80px"
                             label="故障状态">
            </el-table-column>
          </el-table>
        </el-col>
      </el-row>
      <el-row class="pagination">
        <el-col :span="24">
          <div class="block">
            <span class="demonstration"></span>
            <el-pagination @current-change="handleDetailCurrentChange"
                           @size-change="handleDetailSizeChange"
                           :current-page="pageDetailSearch.pageIndex"
                           :page-size="pageDetailSearch.pageSize"
                           :page-sizes="[10,20,100, 500, 1000]"
                           background
                           layout="total,sizes, prev, pager, next, jumper"
                           :total="pageDetailCount"
                           v-if="pageDetailCount>0">
            </el-pagination>
          </div>
        </el-col>
      </el-row>
      <div slot="footer"
           class="dialog-footer">
        <el-button @click="dialogDetailVisible = false">取 消</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import $ from 'jquery'
import { device as api } from '../../api/device'
import * as park from '../../api/park'
// import * as user from '../../api/user'
export default {
  data () {
    // var validateIpPort = (rule, value, callback) => {
    //   if ((this.parkMagdev.fMagIPAddr || '').length > 0) {
    //     if (!/^([0-9]|[1-9]\d{1,3}|[1-5]\d{4}|6[0-4]\d{4}|65[0-4]\d{2}|655[0-2]\d|6553[0-5])$/.test(value)) {
    //       callback(new Error('请以IP:端口的形式填写'))
    //     }
    //   }
    //   callback()
    // }
    return {
      tableHeight: 0,
      loading: false,
      logLoading: false,
      isRead: false,
      map: {},
      is_edit: false,
      is_del: false,
      map_search_list: [],
      dialogTitle: '',
      dialogDetailTitle: '',
      dialogVisible: false,
      dialogDetailVisible: false,
      pageDetailData: [],
      pageData: [],
      cust_list: [],
      park_list: [],
      parkList: [],
      pageCount: 0,
      parkMagdev: {
        fMagID: '',
        fCustID: '',
        fParkID: '',
        fRoadName: '',
        fMagIPAddr: '',
        fMagChnlNo: '',
        fMagSN: '',
        fLongitude: '',
        fLatitude: '',
        fRemark: ''
      },
      pageSearch: {
        pageIndex: 1,
        pageSize: 20,
        fCustID: '',
        fParkID: '',
        fMagChnlNo: '',
        fSearchkeyword: ''
      },
      pageDetailCount: 0,
      pageDetailSearch: {
        pageIndex: 1,
        pageSize: 20,
        fCustID: '',
        fParkID: '',
        fMagIPAddr: '',
        fMagChnlNo: '',
        fSearchkeyword: ''

      },
      rules: {
        fCustID: [
          { required: true, message: '请选择客户', trigger: 'change' }
        ],
        fParkID: [
          { required: true, message: '请选择场库', trigger: 'change' }
        ],
        fMagIPAddr: [
          { required: true, message: '请以IP:端口的形式填写网关IP', trigger: 'blur' }
        ],
        fMagChnlNo: [
          { required: true, message: '请输入地磁通道号', trigger: 'blur' }
        ]

      }

    }
  },
  methods: {
    init (index) {
      if (index && index >= 1) {
        this.pageSearch.pageIndex = index
      } else {
        this.pageSearch.pageIndex = 1
      }

      this.loading = true
      api.geomagneticPageList(this.pageSearch).then(res => {
        this.loading = false
        if (res && res.data) {
          var data = res.data
          if (data.IsOk) {
            this.pageData = data.Data.data || []
            this.pageCount = data.Data.count
          } else {
            this.$message.error('提示：' + data.Msg)
          }
        }
      })
    },
    setAddress () {
      var pt = new window.BMapGL.Point(this.parkMagdev.fLongitude, this.parkMagdev.fLatitude)
      var geoc = new window.BMapGL.Geocoder()
      geoc.getLocation(pt, (rs) => {
        this.map.clearOverlays()
        var mk = new window.BMapGL.Marker(pt)
        this.map.addOverlay(mk)
        this.map.panTo(pt)
        this.parkMagdev.fRoadName = rs.address || ''
      })
    },
    address_keyup (e) {
      if ((this.parkMagdev.fRoadName || '').trim().length <= 0) {
        this.map_search_list = []
        this.parkMagdev.fRoadName = ''
        this.parkMagdev.fLongitude = ''
        this.parkMagdev.fLatitude = ''
        return false
      }
      $(this.$el).find('.search_list .el-row').removeClass('selected')
      var options = {
        onSearchComplete: (results) => {
          if (local.getStatus() === 0) {
            this.map_search_list = []
            for (var i = 0; i < results.getCurrentNumPois(); i++) {
              if (i < 6) {
                this.map_search_list.push(results.getPoi(i))
              }
            }
          }
        }
      }
      var local = new window.BMapGL.LocalSearch(this.map, options)
      local.search(this.parkMagdev.fRoadName.trim())
    },
    map_search_change (address, index) {
      $(this.$el).find('.search_list .el-row').removeClass('selected')
      $(this.$el).find('.search_list .el-row:eq(' + index + ')').addClass('selected')
      this.parkMagdev.fRoadName = address.address || ''
      this.parkMagdev.fLongitude = address.point.lng
      this.parkMagdev.fLatitude = address.point.lat
      this.map.clearOverlays()
      var mk = new window.BMapGL.Marker(address.point)
      this.map.addOverlay(mk)
      this.map.panTo(address.point)
    },
    createBaiduMap () {
      this.map = new window.BMapGL.Map('parkBaiduMap')// 显示标签
      var point = new window.BMapGL.Point(116.331398, 39.897445)
      this.map.centerAndZoom(point, 16)
      this.map.enableScrollWheelZoom(true)
      var geoc = new window.BMapGL.Geocoder()
      this.map.addControl(new window.BMapGL.NavigationControl())
      this.map.enableAutoResize()
      if (this.parkMagdev.fLongitude > 0 && this.parkMagdev.fLatitude > 0) {
        this.map.clearOverlays()
        var newPoint = new window.BMapGL.Point(this.parkMagdev.fLongitude, this.parkMagdev.fLatitude)
        var marker = new window.BMapGL.Marker(newPoint)
        this.map.addOverlay(marker)
        this.map.panTo(newPoint)
      }
      this.map.addEventListener('click', (e) => {
        $(this.$el).find('.search_list .el-row').removeClass('selected')
        this.map_search_list = []
        var pt = new window.BMapGL.Point(e.latlng.lng, e.latlng.lat)
        geoc.getLocation(pt, (rs) => {
          // var addComp = rs.addressComponents
          this.map.clearOverlays()
          var mk = new window.BMapGL.Marker(pt)
          this.map.addOverlay(mk)
          this.map.panTo(pt)
          this.parkMagdev.fRoadName = rs.address || ''
          this.parkMagdev.fLongitude = pt.lng
          this.parkMagdev.fLatitude = pt.lat
        })
      })
    },
    handleDetail (index, row) {
      this.dialogDetailTitle = '【(' + row.fCustNo + ')' + '-' + row.fParkName + '-' + row.fMagIPAddr + '】查看地磁信号消息'
      this.pageDetailSearch.pageIndex = 1
      this.pageDetailSearch.pageSize = 20
      this.pageDetailSearch.fCustID = row.fCustID
      this.pageDetailSearch.fParkID = row.fParkID
      this.pageDetailSearch.fMagIPAddr = row.fMagIPAddr
      this.pageDetailSearch.fMagChnlNo = row.fMagChnlNo
      this.dialogDetailVisible = true
      this.initLog()
    },
    handleDel (index, row) {
      this.$confirm('此操作将永久删除该地磁[' + row.fMagIPAddr + ']信息, 是否继续?', '提示', {
        cancelButtonText: '取消',
        confirmButtonText: '确定',
        type: 'warning'
      }).then(() => {
        api.delGeomagnetic({ fMagID: row.fMagID }).then(res => {
          if (res && res.data) {
            var data = res.data
            if (data.IsOk) {
              this.$message({
                type: 'success',
                message: '删除成功!'
              })
              this.init()
            } else {
              this.$message.error(data.Msg)
            }
          }
        })
      }).catch(() => { })
    },
    add () {
      this.parkMagdev = this.$options.data().parkMagdev
      if (this.$refs.ruleForm) {
        this.$refs.ruleForm.clearValidate()
      }
      this.dialogTitle = '新增地磁设备信息'
      this.dialogVisible = true
      this.isRead = false
      this.$nextTick(() => {
        this.createBaiduMap()
      })
    },
    submitForm (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.isRead) { return }
          api.editGeomagnetic(this.parkMagdev).then(res => {
            if (res && res.data) {
              var data = res.data
              if (data.IsOk) {
                this.dialogVisible = false
                this.$message({
                  type: 'success',
                  message: data.Msg
                })
                this.init()
              } else {
                this.$message.error(data.Msg)
              }
            }
          })
        }
      })
    },
    initLog (index) {
      if (index && index >= 1) {
        this.pageDetailSearch.pageIndex = index
      } else {
        this.pageDetailSearch.pageIndex = 1
      }

      this.logLoading = true
      api.geomagneticBusPageList(this.pageDetailSearch).then(res => {
        this.logLoading = false
        if (res && res.data) {
          var data = res.data
          if (data.IsOk) {
            this.pageDetailData = data.Data.data
            this.pageDetailCount = data.Data.count
          } else {
            this.$message.error('提示：' + data.Msg)
          }
        }
      })
    },
    indexMethod (index) {
      return this.pageSearch.pageSize * (this.pageSearch.pageIndex - 1) + index + 1
    },
    DetailIndexMethod (index) {
      return this.pageDetailSearch.pageSize * (this.pageDetailSearch.pageIndex - 1) + index + 1
    },
    handleSizeChange (val) {
      this.pageSearch.pageSize = val
      this.init(this.pageSearch.pageIndex)
    },
    handleCurrentChange (val) {
      this.init(val)
    },
    handleDetailSizeChange (val) {
      this.pageDetailSearch.pageSize = val
      this.initLog(this.pageDetailSearch.pageIndex)
    },
    handleDetailCurrentChange (val) {
      this.initLog(val)
    },
    setTableHeight (obj) {
      let clientHeight = obj.getRJPageSize.getRJPageSize()[3] - 205
      obj.tableHeight = clientHeight
    },
    handleInfo (index, row, isRead) {
      this.parkMagdev = this.$options.data().parkMagdev
      if (this.$refs.ruleForm) {
        this.$refs.ruleForm.clearValidate()
      }
      var msg = isRead ? '查看' : '编辑'
      this.dialogTitle = '【 (' + row.fCustNo + ')' + ' - ' + row.fParkName + '】' + msg + '地磁设备信息'
      this.dialogVisible = true
      this.isRead = isRead
      api.geomagneticInfo({ fMagID: row.fMagID }).then(res => {
        if (res && res.data) {
          var data = res.data
          if (data.IsOk) {
            Object.assign(this.parkMagdev, data.Data || {})
            if (this.parkMagdev.fCustID > 0) {
              this.changePark(this.parkMagdev.fCustID, false)
            }
            console.info(this.parkMagdev)
          } else {
            this.$message.error('提示：' + data.Msg)
          }
        }
      })
      this.$nextTick(() => {
        this.createBaiduMap()
      })
    },
    loadOptions () {
      park.getCustByGroup().then(res => {
        if (res && res.data) {
          var data = res.data
          if (data.IsOk) {
            this.cust_list = data.Data || []
          } else {
            this.$message.error('提示：加载客户列表失败')
          }
        }
      })
    },
    changePark (fCustID, isInit) {
      if (isInit) {
        this.parkMagdev.fParkID = ''
      }
      this.parkList = []
      // 加载场库
      park.getParkList({ fCustID: fCustID }).then(res => {
        if (res && res.data) {
          var data = res.data
          if (data.IsOk) {
            this.parkList = data.Data
          } else {
            this.$message.error('提示：加载场库列表失败')
          }
        }
      })
    },
    loadPark (fCustID) {
      this.pageSearch.fParkID = ''
      this.park_list = []
      // 加载在场数据列表
      // this.page_list()
      if (!fCustID) { return }
      // 加载场库
      park.getParkList({ fCustID: fCustID }).then(res => {
        if (res && res.data) {
          var data = res.data
          if (data.IsOk) {
            this.park_list = data.Data
          } else {
            this.$message.error('提示：加载场库列表失败')
          }
        }
      })
    }
  },
  created () {
    // user.getCurrentUserPers({ perTypeId: 76000 }).then(res => {
    //   if (res && res.data) {
    //     var data = res.data
    //     if (data.IsOk) {
    //       if (data.Data) {
    //         this.is_edit = data.Data.data.is_edit
    //         this.is_del = data.Data.data.is_del
    //       }
    //     } else {
    //       this.$message.error('提示：加载当前用户权限信息失败')
    //     }
    //   }
    // })
  },
  mounted () {
    window.onresize = () => {
      this.setTableHeight(this)
    }
    this.loadOptions()
  },
  updated () {
    this.setTableHeight(this)
  }
}
</script>
<style>
/* dialog弹出框样式 */
#geomagneticMain .el-dialog__headerbtn {
  top: 10px;
  font-size: 20px;
}
#geomagneticMain .el-dialog__title {
  color: white;
}
#geomagneticMain .el-dialog__header {
  background-color: #337ab7;
  padding: 10px;
}
#geomagneticMain .el-dialog__body {
  padding: 10px 10px;
}
#geomagneticMain .is-disabled .el-input__inner,
#geomagneticMain .is-disabled .el-textarea__inner {
  color: #606266;
}
#geomagneticMain .fRemark_item .el-form-item__content {
  height: auto;
}
#geomagneticMain .warning-row {
  color: #f56c6c;
}
</style>
<style scoped>
.add {
  text-align: right;
}
#geomagneticMain .rowsData {
  border: 1px solid #dcdfe6;
  padding: 5px;
  overflow: auto;
}
.pageSearch .el-form-item {
  margin-bottom: 5px;
}
#geomagneticMain .page-row {
  font-size: 16px;
}
#geomagneticMain .el-table__empty-text {
  font-size: 13px;
}
.search_list .t {
  color: #1eb1fb;
  font-weight: 700;
  min-height: 35px;
  line-height: 35px;
  font-size: 14px;
  padding: 0 7px;
}
#parkBaiduMap {
  float: left;
}
.road_item {
  margin-bottom: 0px;
}
.search_list .a {
  min-height: 20px;
  line-height: 20px;
  font-size: 14px;
  color: #666;
  padding: 0 7px;
}
.search_list {
  height: 300px;
  width: 30%;
  overflow-y: auto;
  float: left;
}
.search_list .el-row {
  margin-top: 0px;
}
.search_list .el-row.selected,
.search_list .el-row:hover {
  background: #dcd9d9;
  cursor: pointer;
}
.el-select {
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/view/park/geomagneticMain.vue